export default __webpack_public_path__ + "static/media/gallery-5-3.590f04eb.webp";